angular.module('limousineModule').component('limousineError', {
	templateUrl: 'limousineError/limousineError.html',
	bindings: {
		existItem: '<',
		searchType: '<',
		emailUsRpc: '@',
		companyPhone: '@',
		buildingName: '<'
	},
	controller: ['$http', function($http) {
	}]
});
